import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getFilteredJobCountByStatus } from "../Actions/API/Job/JobActions"
import { MainThunkDispatch } from "../Reducers"
import { useAppState } from "./useReduxState"
import { APIJobsPerStatusModel } from "../Models/API/APIJobsPerStatusModel"
import { getValue } from "../Models/Client/FetchState"

const noParams = {}

export function useJobCount(
    appID: string,
    options?: { refreshInterval?: number }
): APIJobsPerStatusModel | undefined {
    const dispatch = useDispatch<MainThunkDispatch>()
    const count = useAppState(state =>
        state.api.jobs.jobCount[appID]?.get("app")
    )
    const refreshInterval = options?.refreshInterval

    useEffect(() => {
        if (count === undefined) {
            dispatch(getFilteredJobCountByStatus(appID, "app", noParams))
        }
    }, [appID, dispatch, count])

    useEffect(() => {
        if (refreshInterval === undefined) {
            return
        }

        const interval = window.setInterval(() => {
            dispatch(getFilteredJobCountByStatus(appID, "app", noParams))
        }, refreshInterval)

        return () => window.clearInterval(interval)
    }, [appID, dispatch, refreshInterval])

    return getValue(count)?.data
}
